// English reference texts for the application
// These are used when language is set to 'en'
// The key structure matches the Arabic translations in translations.js
export const englishTexts = {
    'app.dashboard': 'Dashboard',
    'app.home': 'Home',
    'app.settings': 'Settings',
    'app.reports': 'Reports',
    'app.notifications': 'Notifications',
    'app.profile': 'Profile',
    'app.logout': 'Logout',
    'app.admin': 'Admin',
    'app.user': 'User',
    'app.users': 'Users',
    'app.roles_permissions': 'Roles & Permissions',
    'buttons.add_new': 'Add New',
    'buttons.edit': 'Edit',
    'buttons.save': 'Save',
    'buttons.cancel': 'Cancel',
    'buttons.delete': 'Delete',
    'buttons.view': 'View',
    'buttons.details': 'Details',
    'buttons.search': 'Search',
    'buttons.filter': 'Filter',
    'buttons.export': 'Export',
    'buttons.print': 'Print',
    'buttons.refresh': 'Refresh',
    'buttons.back': 'Back',
    'buttons.confirm': 'Confirm',
    'buttons.close': 'Close',
    'customers.customers': 'Customers',
    'customers.add_customer': 'Add Customer',
    'customers.edit_customer': 'Edit Customer',
    'customers.delete_customer': 'Delete Customer',
    'customers.customer_profile': 'Customer Profile',
    'customers.view_vehicles': 'View Vehicles',
    'customers.customer_balance': 'Customer Balance',
    'customers.customer_history': 'Customer History',
    'vehicles.vehicles': 'Vehicles',
    'vehicles.add_vehicle': 'Add Vehicle',
    'vehicles.edit_vehicle': 'Edit Vehicle',
    'vehicles.delete_vehicle': 'Delete Vehicle',
    'vehicles.vehicle_details': 'Vehicle Details',
    'vehicles.update_mileage': 'Update Mileage',
    'vehicles.service_history': 'Service History',
    'vehicles.plate_number': 'Plate Number',
    'vehicles.vin': 'VIN',
    'vehicles.model': 'Model',
    'vehicles.year': 'Year',
    'vehicles.mileage': 'Mileage',
    'status.status': 'Status',
    'status.open': 'Open',
    'status.in_progress': 'Repair',
    'status.waiting_for_parts': 'Waiting for Parts',
    'status.completed': 'Completed',
    'status.delivered': 'Delivered',
    'status.cancelled': 'Cancelled',
    'status.diagnosis': 'Diagnosis',
    'status.waiting_approval': 'Waiting Approval',
    'status.quotation': 'Quotation',
    'status.approved': 'Approved',
    'status.repair': 'In Repair',
    'status.delivering': 'Delivering',
    'status.quality_check': 'Quality Check',
    'status.ready': 'Ready for Delivery',
    'nav.dashboard': 'Dashboard',
    'nav.operations': 'Operations',
    'nav.customers': 'Customers',
    'nav.technicians': 'Technicians',
    'nav.suppliers': 'Suppliers',
    'nav.inventory': 'Inventory',
    'nav.services': 'Services',
    'nav.documents': 'Documents',
    'nav.finance': 'Finance',
    'nav.archive': 'Archive',
    'nav.import': 'Import Data',
    'nav.users': 'Users',
    'nav.profile': 'Profile',
    'nav.settings': 'Settings',
    'nav.finance_accounting': 'Finance & Accounting',
    'nav.chart_of_accounts': 'Chart of Accounts',
    'nav.financial_statements': 'Financial Statements',
    'nav.journal': 'Journal',
    'nav.taxes': 'Taxes',
    'nav.abu_fahd_financial_ai': 'AbuFahd Financial AI',
    'nav.fault_knowledge': 'Knowledge Base',
    'nav.denso_diagnostics': 'Denso Diagnostics',
    'nav.print_quotes': 'Print & Quotes',
    'nav.templates_manager': 'Documents & Templates',
    'nav.workshop_system': 'Workshop Management System',
    'nav.moltbot': 'MoltBot',
    'dashboard.title': 'Dashboard',
    'dashboard.overview': 'Workshop Overview',
    'dashboard.total_vehicles': 'Total Vehicles',
    'dashboard.in_progress': 'Repair',
    'dashboard.ready': 'Ready for Delivery',
    'dashboard.technicians': 'Available Technicians',
    'dashboard.new_vehicle': 'New Vehicle',
    'dashboard.search': 'Search by customer name or plate number...',
    // camelCase keys used in Dashboard.jsx
    'dashboard.totalVehicles': 'Total Vehicles',
    'dashboard.inProgress': 'In Progress',
    'dashboard.newVehicle': 'New Vehicle',
    'dashboard.searchPlaceholder': 'Search by plate number or customer name...',
    'dashboard.activeToday': 'Active Today',
    'dashboard.deliveredToday': 'Delivered Today',
    'dashboard.waitingParts': 'Waiting for Parts',
    'dashboard.waitingPayment': 'Waiting for Payment',
    'dashboard.inDelivery': 'In Delivery',
    'dashboard.inDiagnosis': 'In Diagnosis',
    'dashboard.busyTechs': 'Busy',
    'dashboard.freeTechs': 'Available',
    // vehicle card labels
    'dashboard.entryDateLabel': 'Entry Date',
    'dashboard.customerLabel': 'Customer',
    'dashboard.progressLabel': 'Progress',
    'dashboard.responsibleTechnicianLabel': 'Responsible Technician',
    'dashboard.openVehicleDetails': 'Open Vehicle Details',
    'dashboard.vinLabel': 'VIN',
    'dashboard.visitsLabel': 'Visits',
    'dashboard.visitUnit': 'visit',
    'dashboard.lastUpdateLabel': 'Last Update',
    'dashboard.estimatedCostLabel': 'Estimated Cost',
    // Print / Documents
    'print.print': 'Print',
    'print.print_operation': 'Print operation',
    'print.invoice_number': 'Invoice Number',
    'common.all': 'All',
    'common.save': 'Save',
    'common.cancel': 'Cancel',
    'common.delete': 'Delete',
    'common.edit': 'Edit',
    'common.add': 'Add',
    'common.search': 'Search',
    'common.loading': 'Loading...',
    'common.no_data': 'No Data',
    'common.success': 'Success',
    'common.error': 'Error',
    'common.confirm_delete': 'Are you sure you want to delete?',
    'common.print': 'Print',
    'common.details': 'Details',
    'common.view': 'View',
    'common.total': 'Total',
    'common.currency': 'SAR',
    'common.unknown': 'Unknown',
    'common.not_specified': 'Not specified',
    'common.urgent': 'Urgent',
    'inventory.spare_parts': 'Spare Parts',
    'inventory.inventory': 'Inventory',
    'inventory.parts_dashboard': 'Parts Dashboard',
    'inventory.suppliers': 'Suppliers',
    'inventory.add_item': 'Add Item',
    'inventory.edit_item': 'Edit Item',
    'inventory.delete_item': 'Delete Item',
    'inventory.stock_in': 'Stock In',
    'inventory.stock_out': 'Stock Out',
    'inventory.low_stock_alert': 'Low Stock Alert',
    'inventory.item_code': 'Item Code',
    'inventory.quantity': 'Quantity',
    'inventory.unit_price': 'Unit Price',
    'reports_module.analytics': 'Analytics',
    'reports_module.daily_report': 'Daily Report',
    'reports_module.monthly_report': 'Monthly Report',
    'reports_module.financial_report': 'Financial Report',
    'reports_module.profit_loss': 'Profit & Loss',
    'reports_module.cash_flow': 'Cash Flow',
    'reports_module.export_pdf': 'Export PDF',
    'reports_module.export_excel': 'Export Excel',
    'reports_module.summary': 'Summary',
    'reports_module.kpi': 'KPIs',
    'work_orders.work_orders': 'Work Orders',
    'work_orders.create_work_order': 'Create Work Order',
    'work_orders.edit_work_order': 'Edit Work Order',
    'work_orders.assign_technician': 'Assign Technician',
    'work_orders.change_status': 'Change Status',
    'work_orders.start_work': 'Start Work',
    'work_orders.complete_work': 'Complete Work',
    'work_orders.deliver_vehicle': 'Deliver Vehicle',
    'work_orders.cancel_order': 'Cancel Order',
    'work_orders.job_description': 'Job Description',
    'work_orders.estimated_time': 'Estimated Time',
    'work_orders.completion_date': 'Completion Date',
    'work_orders.assigned_technician': 'Assigned Technician',
    'staff.technicians': 'Technicians',
    'staff.mechanic': 'Mechanic',
    'staff.supervisor': 'Supervisor',
    'staff.add_technician': 'Add Technician',
    'staff.edit_technician': 'Edit Technician',
    'staff.assign_job': 'Assign Job',
    'staff.attendance': 'Attendance',
    'staff.working_hours': 'Working Hours',
    'staff.performance_report': 'Performance Report',
    'invoices.invoices': 'Invoices',
    'invoices.create_invoice': 'Create Invoice',
    'invoices.edit_invoice': 'Edit Invoice',
    'invoices.delete_invoice': 'Delete Invoice',
    'invoices.view_invoice': 'View Invoice',
    'invoices.print_invoice': 'Print Invoice',
    'invoices.apply_discount': 'Apply Discount',
    'invoices.add_tax': 'Add Tax',
    'invoices.invoice_number': 'Invoice Number',
    'invoices.invoice_date': 'Invoice Date',
    'invoices.total_amount': 'Total Amount',
    'invoices.discount': 'Discount',
    'invoices.vat': 'VAT',
    'invoices.net_amount': 'Net Amount',
    'payments.payments': 'Payments',
    'payments.add_payment': 'Add Payment',
    'payments.payment_method': 'Payment Method',
    'payments.cash': 'Cash',
    'payments.credit_card': 'Credit Card',
    'payments.bank_transfer': 'Bank Transfer',
    'payments.mark_as_paid': 'Mark as Paid',
    'payments.partial_payment': 'Partial Payment',
    'payments.paid': 'Paid',
    'payments.unpaid': 'Unpaid',
    'payments.partially_paid': 'Partially Paid',
    'auth.login': 'Login',
    'auth.username': 'Username',
    'auth.password': 'Password',
    'auth.remember_me': 'Remember Me',
    'auth.forgot_password': 'Forgot Password?',
    'auth.change_password': 'Change Password',
    'system.backup': 'Backup',
    'system.restore': 'Restore',
    'system.system_settings': 'System Settings',
    // Messages
    'messages.success_saved': 'Saved Successfully',
    'messages.success_updated': 'Updated Successfully',
    'messages.success_deleted': 'Deleted Successfully',
    'messages.error_occurred': 'An Error Occurred',
    'messages.loading_data': 'Loading Data...',
    'messages.no_results': 'No Results Found',
    'messages.confirm_action': 'Are you sure?',
    'messages.action_cancelled': 'Action Cancelled',
    'messages.processing': 'Processing...',
    // Forms
    'forms.required_field': 'This field is required',
    'forms.invalid_email': 'Invalid email address',
    'forms.invalid_phone': 'Invalid phone number',
    'forms.name': 'Name',
    'forms.phone': 'Phone',
    'forms.email': 'Email',
    'forms.address': 'Address',
    'forms.notes': 'Notes',
    'forms.select': 'Select',
    'forms.select_option': 'Select an option',
    // Operations
    'operations.title': 'Operations',
    'operations.subtitle': 'Manage purchase and sales operations',
    'operations.new_operation': 'New Operation',
    'operations.account': 'Account',
    'operations.select_account': 'Select Account',
    'operations.vehicle': 'Vehicle',
    'operations.select_vehicle': 'Select Vehicle',
    'operations.visit': 'Visit',
    'operations.date': 'Date',
    'operations.operation_type': 'Operation Type',
    'operations.purchase': 'Purchase',
    'operations.sale': 'Sale',
    'operations.partner_type': 'Partner Type',
    'operations.supplier': 'Supplier',
    'operations.customer': 'Customer',
    'operations.partner_name': 'Partner Name',
    'operations.add_item': 'Add Item',
    'operations.item_type': 'Item Type',
    'operations.part': 'Part',
    'operations.service': 'Service',
    'operations.item_name': 'Item Name',
    'operations.quantity': 'Quantity',
    'operations.price': 'Price',
    'operations.total': 'Total',
    'operations.payment_method': 'Payment Method',
    'operations.cash': 'Cash',
    'operations.card': 'Card',
    'operations.transfer': 'Transfer',
    'operations.subtotal': 'Subtotal',
    'operations.create_operation': 'Create Operation',
    'operations.recent_operations': 'Recent Operations',
    'operations.no_operations': 'No operations found',
    // Operations - camelCase keys used in Operations.jsx
    'operations.addItems': 'Items',
    'operations.addItem': 'Add Item',
    'operations.items': 'Items',
    'operations.selectPart': 'Select Part',
    'operations.selectService': 'Select Service',
    'operations.selectAccount': 'Select Account',
    'operations.recentOperations': 'Recent Operations',
    'operations.operationType': 'Operation Type',
    'operations.paymentMethod': 'Payment Method',
    'operations.partner': 'Partner',
    'operations.submit': 'Submit',
    'operations.customerName': 'Customer Name',
    'operations.supplierName': 'Supplier Name',
    'operations.customName': 'Custom Name',
    'operations.credit': 'Credit',
    'operations.SAR': 'SAR',
    // Operations extra labels
    'operations.scopeLabel': 'Operation Scope',
    // Vehicle finance
    'vehicle_finance.workshop_due': 'Workshop Due',
    'vehicle_finance.suppliers_due': 'Suppliers Due',
    'vehicle_finance.total_paid': 'Total Paid',
    'vehicle_finance.advance_paid': 'Advance Payment',
    'vehicle_finance.balance': 'Balance',
    'vehicle_finance.credit': 'Customer Credit',
    'operations.scopeVehicle': 'Vehicle Operation',
    'operations.scopeWorkshop': 'General Workshop Operation',
    'operations.operationDateLabel': 'Operation Date',
    'operations.no_accounts': 'No accounts available',
    'operations.loading_accounts': 'Loading accounts...',
    'operations.payment_receipt_optional': 'Payment Receipt (optional)',
    'operations.credit_unpaid': 'Credit (unpaid)',
    'operations.confirm_credit_payment': 'Confirm Credit Payment',
    'operations.payment_confirm_failed': 'Payment confirmation failed',
    'operations.qty': 'Qty',
    'operations.items_count': 'Items',
    'operations.saved_successfully': 'Operation saved successfully',
    'operations.save_failed': 'Failed to save operation',
    'operations.items_required': 'Add at least one item before saving',
    'operations.select_vehicle_required': 'Select a vehicle first',
    // Settings
    'settings.title': 'Settings',
    'settings.workshop_info': 'Workshop Information',
    'settings.workshop_name': 'Workshop Name',
    'settings.workshop_phone': 'Phone Number',
    'settings.workshop_email': 'Email Address',
    'settings.workshop_address': 'Address',
    'settings.system_appearance': 'System & Appearance',
    'settings.language': 'Language',
    'settings.theme': 'Theme',
    // AbuFahad (floating chat)
    'abu_fahad.title': 'AbuFahad',
    'abu_fahad.subtitle': 'Financial Assistant',
    'abu_fahad.greeting': "Hello, I'm AbuFahad. What would you like to review today? You can choose an account for auditing or type your question directly.",
    'abu_fahad.new_chat': 'New chat',
    'abu_fahad.new_chat_greeting': 'New chat started. What would you like to analyze now? You can choose an account for auditing or type your question directly.',
    'abu_fahad.open_chat': 'Open AbuFahad chat',
    'abu_fahad.account_optional': 'Account (optional)',
    'abu_fahad.no_account': 'No account selected',
    'abu_fahad.placeholder': 'Type your financial question here...',
    'abu_fahad.no_response': 'Could not get a response from AbuFahad right now.',
    'abu_fahad.connection_error': 'Could not connect to AbuFahad. Please try again.',
    'abu_fahad.details': 'Details',
    'abu_fahad.latency_note': 'Note: replies may take 10–30 seconds depending on load.',
    'settings.currency': 'Currency',
    'settings.light': 'Light',
    'settings.dark': 'Dark',
    'settings.arabic': 'Arabic',
    'settings.english': 'English',
    'settings.save_changes': 'Save Changes',
    'settings.saving': 'Saving...',
    'settings.tax_settings': 'Tax Settings',
    'settings.enable_tax': 'Enable Tax',
    'settings.tax_rate': 'Tax Rate',
    // Parts
    'parts.title': 'Spare Parts',
    'parts.inventory': 'Inventory',
    'parts.add_part': 'Add Part',
    'parts.edit_part': 'Edit Part',
    'parts.part_number': 'Part Number',
    'parts.part_name': 'Part Name',
    'parts.category': 'Category',
    'parts.purchase_price': 'Purchase Price',
    'parts.selling_price': 'Selling Price',
    'parts.quantity': 'Quantity',
    'parts.min_quantity': 'Minimum Quantity',
    'parts.supplier': 'Supplier',
    'parts.location': 'Location',
    'parts.low_stock': 'Low Stock',
    'parts.import_parts': 'Import Parts',
    'parts.upload_image': 'Upload Image',
    // Suppliers
    'suppliers.title': 'Suppliers',
    'suppliers.add_supplier': 'Add Supplier',
    'suppliers.supplier_name': 'Supplier Name',
    'suppliers.contact_person': 'Contact Person',
    'suppliers.city': 'City',
    'suppliers.rating': 'Rating',
    // Vehicles Page
    'vehicles_page.new_vehicle': 'New Vehicle Reception',
    'vehicles_page.vehicle_info': 'Vehicle Information',
    'vehicles_page.customer_info': 'Customer Information',
    'vehicles_page.services_info': 'Maintenance Services',
    'vehicles_page.select_services': 'Select Services',
    'vehicles_page.manual_service': 'Manual Service',
    'vehicles_page.service_name': 'Service Name',
    'vehicles_page.service_price': 'Service Price',
    'vehicles_page.add_manual': 'Add Manually',
    'vehicles_page.assign_technician': 'Assign Technician',
    'vehicles_page.customer_name': 'Customer Name',
    'vehicles_page.customer_phone': 'Phone Number',
    'vehicles_page.customer_email': 'Email Address',
    // Vehicle Details
    'vehicle_details.title': 'Vehicle Details',
    'vehicle_details.vehicle_info': 'Vehicle Information',
    'vehicle_details.customer_info': 'Customer Information',
    'vehicle_details.status': 'Status',
    'vehicle_details.assigned_technician': 'Assigned Technician',
    'vehicle_details.notes': 'Notes',
    'vehicle_details.update': 'Update',
    'vehicle_details.updating': 'Updating...',
    'vehicle_details.services': 'Services',
    'vehicle_details.parts': 'Parts',
    'vehicle_details.files': 'Files',
    'vehicle_details.operations': 'Operations',
    'vehicle_details.approvals': 'Approvals',
    'vehicle_details.visits': 'Visits',
    'vehicle_details.add_service': 'Add Service',
    'vehicle_details.add_part': 'Add Part',
    'vehicle_details.upload_file': 'Upload File',
    'vehicle_details.print': 'Print',
    'vehicle_details.delete': 'Delete',
    'vehicle_details.photo': 'Photo',
    'vehicle_details.document': 'Document',
    'vehicle_details.invoice': 'Invoice',
    'vehicle_details.quotation': 'Quotation',
    'vehicle_details.repair_report': 'Repair Report',
    'vehicle_details.new_visit': 'New Visit',
    'vehicle_details.current_visit': 'Current Visit',
    'vehicle_details.entry_date': 'Entry Date',
    'vehicle_details.exit_date': 'Exit Date',
    'vehicle_details.visit_notes': 'Visit Notes',
    'vehicle_details.brand_model': 'Brand & Model',
    'vehicle_details.vin_number': 'VIN Number',
    'vehicle_details.color': 'Color',
    'vehicle_details.registered_services': 'Registered Services for this Vehicle',
    'vehicle_details.items_edit_hint': 'You can add/edit services and parts from the items table above',
    // Quick Actions
    'quick_actions.title': 'Quick Actions',
    'quick_actions.change_status': 'Change Status',
    'quick_actions.current_status': 'Current Status',
    'quick_actions.new_status': 'New Status',
    'quick_actions.print_quotation': 'Print Quotation',
    'quick_actions.print_invoice': 'Print Invoice',
    'quick_actions.send_approval': 'Send Approval',
    'quick_actions.add_operations': 'Add Operations',
    'quick_actions.delete_vehicle': 'Delete Vehicle',
    'quick_actions.confirm_delete': 'Are you sure you want to delete this vehicle?',
    'quick_actions.cancel': 'Cancel',
    'quick_actions.confirm': 'Confirm',
    'quick_actions.close': 'Close',
    'quick_actions.vehicle_options': 'Vehicle Options',
    'quick_actions.quick_actions': 'Quick Actions',
    'quick_actions.diagnosis_report': 'Diagnosis Report',
    'quick_actions.receipt': 'Receipt',
    'quick_actions.details': 'Details',
    'quick_actions.spare_parts': 'Spare Parts',
    'quick_actions.operations': 'Operations',
    'quick_actions.subtitle': 'Select an action for this vehicle'
};
